<rt-infobox
  [isDismissible]="true"
  [messagePaddingSmall]="true"
  [type]="'warning'"
  [iconName]="'warning'"
  [heading]="'app.mailbox.candidate_with_internal_email_infobox.title' | translate"
  (dismissClick)="dismiss.emit()"
>
  <p
    [innerHTML]="
      messageTranslationKey()
        | translate
          : {
              href: ('app.mailbox.candidate_with_internal_email_infobox.help_article' | translate),
            }
    "
    margin-bottom-small
  ></p>
  <blockquote>
    {{
      (emails().length === 1
        ? 'app.mailbox.candidate_with_internal_email_infobox.removed'
        : 'app.mailbox.candidate_with_internal_email_infobox.removed_many'
      ) | translate: { emails: emailsStr() }
    }}
  </blockquote>
</rt-infobox>
